<template>
  <section class="section">
    <h2 class="title is-4">Transformation pipeline</h2>

    <ul>
      <li>Last Modified: 04.06.2020</li>
      <li>Last Run: 03.06.2020</li>
      <li>Created by: bob@bafu.admin.ch</li>
    </ul>

    <form>
      <b-field></b-field>

      <b-field>
        <b-button type="is-primary" icon-left="play">Run pipeline</b-button>
      </b-field>
    </form>
  </section>
</template>

<script>
export default {
  name: 'Job',
}
</script>
